// ─── All available permissions in the system ───
export const PERMISSIONS = {
  // Dashboard
  VIEW_DASHBOARD: 'view_dashboard',

  // Members
  VIEW_MEMBERS: 'view_members',
  ADD_MEMBERS: 'add_members',
  EDIT_MEMBERS: 'edit_members',
  DELETE_MEMBERS: 'delete_members',

  // Financials
  VIEW_FINANCIALS: 'view_financials',
  ADD_FINANCIALS: 'add_financials',
  EDIT_FINANCIALS: 'edit_financials',

  // Member Ledger
  VIEW_MEMBER_LEDGER: 'view_member_ledger',
  ADD_MEMBER_LEDGER: 'add_member_ledger',
  EDIT_MEMBER_LEDGER: 'edit_member_ledger',
  DELETE_MEMBER_LEDGER: 'delete_member_ledger',

  // Income & Expenses
  VIEW_INCOME_EXPENSES: 'view_income_expenses',
  ADD_INCOME_EXPENSES: 'add_income_expenses',
  EDIT_INCOME_EXPENSES: 'edit_income_expenses',
  DELETE_INCOME_EXPENSES: 'delete_income_expenses',

  // Inventory
  VIEW_INVENTORY: 'view_inventory',
  ADD_INVENTORY: 'add_inventory',
  EDIT_INVENTORY: 'edit_inventory',
  DELETE_INVENTORY: 'delete_inventory',

  // Announcements
  VIEW_ANNOUNCEMENTS: 'view_announcements',
  ADD_ANNOUNCEMENTS: 'add_announcements',
  EDIT_ANNOUNCEMENTS: 'edit_announcements',
  DELETE_ANNOUNCEMENTS: 'delete_announcements',

  // MCPD
  VIEW_MCPD: 'view_mcpd',
  ADD_MCPD: 'add_mcpd',
  EDIT_MCPD: 'edit_mcpd',
  DELETE_MCPD: 'delete_mcpd',

  // Events
  VIEW_EVENTS: 'view_events',
  ADD_EVENTS: 'add_events',
  EDIT_EVENTS: 'edit_events',
  DELETE_EVENTS: 'delete_events',

  // AGM
  VIEW_AGM: 'view_agm',
  ADD_AGM: 'add_agm',
  EDIT_AGM: 'edit_agm',
  DELETE_AGM: 'delete_agm',

  // Committee
  VIEW_COMMITTEE: 'view_committee',
  ADD_COMMITTEE: 'add_committee',
  EDIT_COMMITTEE: 'edit_committee',
  DELETE_COMMITTEE: 'delete_committee',

  // Minutes
  VIEW_MINUTES: 'view_minutes',
  ADD_MINUTES: 'add_minutes',
  EDIT_MINUTES: 'edit_minutes',
  DELETE_MINUTES: 'delete_minutes',

  // Council Reports
  VIEW_COUNCIL_REPORT: 'view_council_report',
  ADD_COUNCIL_REPORT: 'add_council_report',
  EDIT_COUNCIL_REPORT: 'edit_council_report',
  DELETE_COUNCIL_REPORT: 'delete_council_report',


  // Certificates
  VIEW_CERTIFICATES: 'view_certificates',
  ADD_CERTIFICATES: 'add_certificates',
  EDIT_CERTIFICATES: 'edit_certificates',
  DELETE_CERTIFICATES: 'delete_certificates',


  // Messages
  VIEW_MESSAGES: 'view_messages',
  EDIT_MESSAGES: 'edit_messages',
  DELETE_MESSAGES: 'delete_messages',

  // Reports
  VIEW_REPORTS: 'view_reports',

  // Page Editor
  VIEW_PAGE_EDITOR: 'view_page_editor',
  ADD_PAGE_EDITOR: 'add_page_editor',
  EDIT_PAGE_EDITOR: 'edit_page_editor',
  DELETE_PAGE_EDITOR: 'delete_page_editor',

  // Payment Gateway
  VIEW_PAYMENT_GATEWAY: 'view_payment_gateway',
  ADD_PAYMENT_GATEWAY: 'add_payment_gateway',
  EDIT_PAYMENT_GATEWAY: 'edit_payment_gateway',
  DELETE_PAYMENT_GATEWAY: 'delete_payment_gateway',

  // Roles & Permissions (superadmin only)
  MANAGE_ROLES: 'manage_roles',

  // Settings
  VIEW_SETTINGS: 'view_settings',
  ADD_SETTINGS: 'add_settings',
  EDIT_SETTINGS: 'edit_settings',
  DELETE_SETTINGS: 'delete_settings',

  // Backup (superadmin only)
  MANAGE_BACKUP: 'manage_backup',

  // QR Codes
  VIEW_QRCODES: 'view_qrcodes',
  ADD_QRCODES: 'add_qrcodes',
  EDIT_QRCODES: 'edit_qrcodes',
  DELETE_QRCODES: 'delete_qrcodes',
};

// ─── Map admin routes to the permission(s) needed to VIEW the page ───
// NOTE: `/admin` and `/admin/dashboard` are intentionally NOT gated here so
// that every admin (regardless of custom role) always has a landing page.
export const ROUTE_PERMISSIONS = {
  '/admin/members':          [PERMISSIONS.VIEW_MEMBERS],
  '/admin/financials':       [PERMISSIONS.VIEW_FINANCIALS],
  '/admin/customer-ledger':  [PERMISSIONS.VIEW_MEMBER_LEDGER],
  '/admin/income-expenses':  [PERMISSIONS.VIEW_INCOME_EXPENSES],
  '/admin/inventory':        [PERMISSIONS.VIEW_INVENTORY],
  '/admin/announcements':    [PERMISSIONS.VIEW_ANNOUNCEMENTS],
  '/admin/mcpd':             [PERMISSIONS.VIEW_MCPD],
  '/admin/events':           [PERMISSIONS.VIEW_EVENTS],
  '/admin/agm':              [PERMISSIONS.VIEW_AGM],
  '/admin/committee':        [PERMISSIONS.VIEW_COMMITTEE],
  '/admin/minute':           [PERMISSIONS.VIEW_MINUTES],
  '/admin/council-report':   [PERMISSIONS.VIEW_COUNCIL_REPORT],
  '/admin/certificates':     [PERMISSIONS.VIEW_CERTIFICATES],
  '/admin/messages':         [PERMISSIONS.VIEW_MESSAGES],
  '/admin/reports':          [PERMISSIONS.VIEW_REPORTS],
  '/admin/page-editor':      [PERMISSIONS.VIEW_PAGE_EDITOR],
  '/admin/payment-gateway':  [PERMISSIONS.VIEW_PAYMENT_GATEWAY],
  '/admin/roles-permissions':[PERMISSIONS.MANAGE_ROLES],
  '/admin/settings':         [PERMISSIONS.VIEW_SETTINGS],
  '/admin/backup':           [PERMISSIONS.MANAGE_BACKUP],
  '/admin/qrcodes':          [PERMISSIONS.VIEW_QRCODES],
};

// ─── Map sidebar links to view permissions so we can hide inaccessible links ───
export const SIDEBAR_PERMISSIONS = ROUTE_PERMISSIONS;

// ─── All permissions grouped by category (for the admin UI) ───
export const PERMISSION_GROUPS = [
  {
    label: 'Dashboard',
    permissions: [PERMISSIONS.VIEW_DASHBOARD],
  },
  {
    label: 'Members',
    permissions: [PERMISSIONS.VIEW_MEMBERS, PERMISSIONS.ADD_MEMBERS, PERMISSIONS.EDIT_MEMBERS, PERMISSIONS.DELETE_MEMBERS],
  },
  {
    label: 'Financials',
    permissions: [PERMISSIONS.VIEW_FINANCIALS, PERMISSIONS.ADD_FINANCIALS, PERMISSIONS.EDIT_FINANCIALS],
  },
  {
    label: 'Member Ledger',
    permissions: [PERMISSIONS.VIEW_MEMBER_LEDGER, PERMISSIONS.ADD_MEMBER_LEDGER, PERMISSIONS.EDIT_MEMBER_LEDGER, PERMISSIONS.DELETE_MEMBER_LEDGER],
  },
  {
    label: 'Income & Expenses',
    permissions: [PERMISSIONS.VIEW_INCOME_EXPENSES, PERMISSIONS.ADD_INCOME_EXPENSES, PERMISSIONS.EDIT_INCOME_EXPENSES, PERMISSIONS.DELETE_INCOME_EXPENSES],
  },
  {
    label: 'Inventory',
    permissions: [PERMISSIONS.VIEW_INVENTORY, PERMISSIONS.ADD_INVENTORY, PERMISSIONS.EDIT_INVENTORY, PERMISSIONS.DELETE_INVENTORY],
  },
  {
    label: 'Announcements',
    permissions: [PERMISSIONS.VIEW_ANNOUNCEMENTS, PERMISSIONS.ADD_ANNOUNCEMENTS, PERMISSIONS.EDIT_ANNOUNCEMENTS, PERMISSIONS.DELETE_ANNOUNCEMENTS],
  },
  {
    label: 'MCPD',
    permissions: [PERMISSIONS.VIEW_MCPD, PERMISSIONS.ADD_MCPD, PERMISSIONS.EDIT_MCPD, PERMISSIONS.DELETE_MCPD],
  },
  {
    label: 'Events',
    permissions: [PERMISSIONS.VIEW_EVENTS, PERMISSIONS.ADD_EVENTS, PERMISSIONS.EDIT_EVENTS, PERMISSIONS.DELETE_EVENTS],
  },
  {
    label: 'AGM',
    permissions: [PERMISSIONS.VIEW_AGM, PERMISSIONS.ADD_AGM, PERMISSIONS.EDIT_AGM, PERMISSIONS.DELETE_AGM],
  },
  {
    label: 'Committee',
    permissions: [PERMISSIONS.VIEW_COMMITTEE, PERMISSIONS.ADD_COMMITTEE, PERMISSIONS.EDIT_COMMITTEE, PERMISSIONS.DELETE_COMMITTEE],
  },
  {
    label: 'Minutes',
    permissions: [PERMISSIONS.VIEW_MINUTES, PERMISSIONS.ADD_MINUTES, PERMISSIONS.EDIT_MINUTES, PERMISSIONS.DELETE_MINUTES],
  },
  {
    label: 'Council Reports',
    permissions: [PERMISSIONS.VIEW_COUNCIL_REPORT, PERMISSIONS.ADD_COUNCIL_REPORT, PERMISSIONS.EDIT_COUNCIL_REPORT, PERMISSIONS.DELETE_COUNCIL_REPORT],
  },
  {
    label: 'Certificates',
    permissions: [PERMISSIONS.VIEW_CERTIFICATES, PERMISSIONS.ADD_CERTIFICATES, PERMISSIONS.EDIT_CERTIFICATES, PERMISSIONS.DELETE_CERTIFICATES],
  },
  {
    label: 'Messages',
    permissions: [PERMISSIONS.VIEW_MESSAGES, PERMISSIONS.EDIT_MESSAGES, PERMISSIONS.DELETE_MESSAGES],
  },
  {
    label: 'Reports',
    permissions: [PERMISSIONS.VIEW_REPORTS],
  },
  {
    label: 'Page Editor',
    permissions: [PERMISSIONS.VIEW_PAGE_EDITOR, PERMISSIONS.ADD_PAGE_EDITOR, PERMISSIONS.EDIT_PAGE_EDITOR, PERMISSIONS.DELETE_PAGE_EDITOR],
  },
  {
    label: 'Payment Gateway',
    permissions: [PERMISSIONS.VIEW_PAYMENT_GATEWAY, PERMISSIONS.ADD_PAYMENT_GATEWAY, PERMISSIONS.EDIT_PAYMENT_GATEWAY, PERMISSIONS.DELETE_PAYMENT_GATEWAY],
  },
  {
    label: 'Settings',
    permissions: [PERMISSIONS.VIEW_SETTINGS, PERMISSIONS.ADD_SETTINGS, PERMISSIONS.EDIT_SETTINGS, PERMISSIONS.DELETE_SETTINGS],
  },
  {
    label: 'QR Codes',
    permissions: [PERMISSIONS.VIEW_QRCODES, PERMISSIONS.ADD_QRCODES, PERMISSIONS.EDIT_QRCODES, PERMISSIONS.DELETE_QRCODES],
  },
  {
    label: 'System',
    permissions: [PERMISSIONS.MANAGE_ROLES, PERMISSIONS.MANAGE_BACKUP],
  },
];

// ─── All permission keys (flat list for the backend) ───
export const ALL_PERMISSIONS = Object.values(PERMISSIONS);
